import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { colors } from 'kangarootime-ui';
import { Dialog, DialogContent, DialogActions, Button, DialogTitle } from '@material-ui/core';
import { DayPickerSingleDateController, CalendarDay } from 'react-dates';
import moment from 'moment';

const DeleteDayOrWeekDialog = ({
  startDate,
  endDate,
  isOpen,
  onClose,
  onSubmit,
  ...props
}) => {
  const [selectedDates, setSelectedDates] = useState([]);

  const renderCalendar = useCallback(calendarProps => {
    const { day, modifiers } = calendarProps;

    if (selectedDates.includes(day)) {
      modifiers && modifiers.add('selected');
    } else {
      modifiers && modifiers.delete('selected');
    }

    return <CalendarDay {...calendarProps} modifiers={modifiers} />;
  }, [selectedDates]);

  const handleDateChange = useCallback(date => {
    const newDates = selectedDates.includes(date) ? selectedDates.filter(d => !date.isSame(d)) : [...selectedDates, date];

    setSelectedDates(newDates);
  }, [selectedDates]);

  const checkOutsideRange = useCallback(date => {
    const isWeekend = date.day() === 0 || date.day() === 6;

    // disable dates that fall outside the start and end date. will ALSO disable today since shifts shouldn't be able to be deleted after they have passed
    return (
      isWeekend ||
      moment(date).isBefore(startDate) ||
      moment(date).isSameOrBefore(moment()) ||
      moment(date).isAfter(endDate)
    );
  }, [startDate, endDate]);

  const handleSubmit = useCallback(() => {
    onSubmit && onSubmit(selectedDates);
  }, [onSubmit, selectedDates]);

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Which date(s) would you like to remove shifts from?</DialogTitle>
      <DialogContent style={{ alignItems: 'center', flexDirection: 'column', display: 'flex' }}>
        <DayPickerSingleDateController
          hideKeyboardShortcutsPanel
          focused
          numberOfMonths={1}
          onDateChange={handleDateChange}
          renderCalendarDay={renderCalendar}
          isOutsideRange={checkOutsideRange}
        />
        <DialogActions style={{ alignSelf: 'flex-end' }}>
          <Button onClick={onClose}>
            Cancel
          </Button>
          <Button
            disabled={selectedDates.length === 0}
            onClick={handleSubmit}
            style={{ color: selectedDates.length && colors.danger }}
          >
            Delete
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

DeleteDayOrWeekDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  startDate: PropTypes.object.isRequired, // moment object
  endDate: PropTypes.object.isRequired // moment object
};

export default DeleteDayOrWeekDialog;
